<template>
    <div class="system-setting">
        <Spin fix size='large' v-if="initing"></Spin>
        <div class="setting-row with-separator">
            <label>缓存技术：</label>
            <iSwitch v-model="useCache" size='large' :disabled='disabledCacheSetting'>
                <span slot="open">开</span>
                <span slot="close">关</span>
            </iSwitch>
        </div>
        <div class="setting-row">
            <Button type="success" class="save-btn" @click="saveSetting()">保存</Button>
        </div>
        <Modal title="保存成功" v-model="saveSuccessed" @on-ok='reloadPage()'>
            <p>保存成功，刷新后立刻生效，是否刷新页面？</p>
        </Modal>
    </div>
</template>
<script>
    import { SettingProperties } from "./systemSetting";
    import systemSetting from "./systemSetting";
    import { fail } from "assert";
    export default {
        data() {
            return {
                useCache: true,
                disabledCacheSetting: false,
                initing: true,
                saveSuccessed: false
            };
        },
        created() {
            if (window.localStorage) {
                let savedSetting = systemSetting.getSetting();
                if (savedSetting) {
                    SettingProperties.forEach(propertyName => {
                        this[propertyName] = savedSetting[propertyName];
                    });
                }
            }
            this.initing = false;
        },
        methods: {
            saveSetting() {
                let saveObj = {};
                SettingProperties.forEach(propertyName => {
                    saveObj[propertyName] = this[propertyName];
                });
                if (systemSetting.saveSetting(saveObj)) {
                    this.saveSuccessed = true;
                } else {
                    this.$Message.error("保存失败");
                }
            },
            reloadPage() {
                window.location.reload();
            }
        }
    };
</script>
<style lang="scss">
@import "./../_common.scss";
$labelWidth: 15em;
.system-setting {
  padding: $normalPadding;
  .setting-row {
    margin-bottom: $normalMargin;
    label {
      margin-bottom: 0;
      line-height: 24px;
      text-align: right;
      width: $labelWidth;
    }
    &.with-separator {
      box-shadow: inset 0 -0.5px 0 0 #dce3ea;
      padding-bottom: $normalPadding;
    }
    .save-btn.tbo-btn {
      margin-left: $labelWidth;
      padding: 4px 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// setting.vue?5e247660